/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolPottedPlantIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-potted-plant"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M8.55 22.8Q7.63 22.8 6.94 22.25Q6.25 21.7 6 20.82L4.85 16.52L19.15 16.52L18 20.82Q17.75 21.7 17.05 22.25Q16.35 22.8 15.45 22.8ZM12 7.88Q12 5.38 13.72 3.56Q15.45 1.75 17.98 1.35Q18.13 1.32 18.27 1.36Q18.43 1.4 18.55 1.52Q18.68 1.65 18.73 1.8Q18.77 1.95 18.75 2.1Q18.43 4.28 16.94 5.84Q15.45 7.4 13.3 7.75L13.3 9.72L20.48 9.72Q21.02 9.72 21.41 10.11Q21.8 10.5 21.8 11.05L21.8 12.43Q21.8 13.53 21.05 14.29Q20.3 15.05 19.32 15.05L4.67 15.05Q3.67 15.05 2.94 14.29Q2.2 13.53 2.2 12.43L2.2 11.05Q2.2 10.5 2.59 10.11Q2.98 9.72 3.52 9.72L10.68 9.72L10.68 7.75Q8.53 7.4 7.05 5.84Q5.58 4.28 5.25 2.1Q5.22 1.95 5.28 1.8Q5.33 1.65 5.45 1.52Q5.58 1.4 5.71 1.36Q5.85 1.32 6 1.35Q8.53 1.75 10.26 3.56Q12 5.38 12 7.88Z" fill={color} />
    </svg>
  );
}
